//DFS algorithm
//Recursive algorithm checking node in order ->up->right->down->left
const visitedNodesInOrder = [];
//bool var to check if we reach destination or not
var found = false;

export function dfs(grid,startNode,finishNode){
    
    dfsStart(grid,startNode,finishNode);
    return visitedNodesInOrder;
}

export function getNodeInPath(){
    if(found){
        return visitedNodesInOrder;
    }
    else{
        return [];
    }
}



function dfsStart(grid,a,b){

    const {row,col} = a;

    if(a===b ){
        visitedNodesInOrder.push(grid[row][col])
        grid[row][col].isVisited = true;
        found = true;
        return;
    }

    if(found === false){
    visitedNodesInOrder.push(grid[row][col]);
    }

    grid[row][col].isVisited = true;

    if(row>0 && grid[row-1][col].isVisited === false && grid[row-1][col].isWall === false){
        dfsStart(grid,grid[row-1][col],b)
    }

    if(col<grid[0].length-1 && grid[row][col+1].isVisited === false&&  grid[row][col+1].isWall === false){
        dfsStart(grid,grid[row][col+1],b)
    }

    if(row<grid.length-1 && grid[row+1][col].isVisited === false && grid[row+1][col].isWall === false){
        dfsStart(grid,grid[row+1][col],b)
    }

    if(col>0 && grid[row][col-1].isVisited === false && grid[row][col-1].isWall === false){
        dfsStart(grid,grid[row][col-1],b)
    }
      
}

